import { render, staticRenderFns } from "./ItemDetails_Packagings.vue?vue&type=template&id=6d296394&"
import script from "./ItemDetails_Packagings.vue?vue&type=script&lang=js&"
export * from "./ItemDetails_Packagings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports